import { render, staticRenderFns } from "./RegesterAdmin.vue?vue&type=template&id=2b364119&scoped=true&"
import script from "./RegesterAdmin.vue?vue&type=script&lang=js&"
export * from "./RegesterAdmin.vue?vue&type=script&lang=js&"
import style0 from "./RegesterAdmin.vue?vue&type=style&index=0&id=2b364119&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b364119",
  null
  
)

export default component.exports